<template>
  <div class="stamp-holder" @click="handleClick">
    <transition name="flip" mode="out-in">
      <div class="stamp" v-if="show" key="imprint" :style="style"></div>
      <!-- <div class="stamp" v-else key="empty">{{ stamp.val }}</div> -->
    </transition>
    <div class="num">{{ stamp.val }}</div>
  </div>
</template>

<script>
export default {
  name: 'flip-stamp',
  props: {
    stamp: { type: Object, require: true },
    imprinted: { type: Boolean, default: false },
    width: { type: String, default: '75%' },
    height: { type: String, default: '75%' },
  },
  computed: {
    show() {
      return this.imprinted;
    },
    style() {
      return {
        background: `url(/img/${this.stamp.img}) no-repeat center center`,
        backgroundSize: 'contain',
        width: this.width,
        height: this.height,
      };
    },
  },
  methods: {
    handleClick() {
      // if (!this.imprinted) {
      //   this.$emit('flip', this.stamp.id);
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.stamp-holder {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.stamp {
  max-width: 320px;
  max-height: 320px;
  box-sizing: border-box;
  font-size: 1.6rem;
}
.empty {
  // background-color: #fff;
}
.num {
  position: absolute;
  top: 0;
  left: 0;
  // bottom: 0;
  // right: 0;
  padding: 8px;
  font-size: 1rem;
  font-weight: bold;
}

.flip-enter-active, .flip-leave-active {
  transition: all 0.6s ease;
  // position: absolute;
}
.flip-enter, .flip-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scale(1.2) rotateY(90deg);
}

@media screen and (min-width:480px) {
  .stamp {
    font-size: 3rem;
  }
  .num {
    padding: 8px;
    font-size: 1.5rem;
  }
}
</style>
